var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"alert-container"},_vm._l((_vm.alerts),function(alert,key){return _c('alert-component',{key:alert.id,attrs:{"alert":alert},on:{"remove":function($event){_vm.$delete(_vm.alerts, key)}}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f41b0802","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AlertContainer.vue
// module id = P3x6
// module chunks = 15